import React from 'react';

function StepFive({ state = {}, dispatch, isDataCloudProject , control, selectedRadioBtnIndex, setSelectedRadioBtnIndex}) {
	const { projectName, projectDescription, useCaseName, appStore, productIntegration } = state;

	return (
		<>
			<div className="mt-8" style={{height: "34rem"}}>
				<div className="text-heading-05 font-bold mb-4">Review summary</div>
				<div className="text-body-02 mb-12">Take a moment to confirm your selections before generating your project.</div>

				<div>
					<section className="items-center justify-center h-full">
						<div className="flex flex-col">
							<div className="flex flex-row pb-6">
								<div className="order-1 w-1/4">
									<label className="text-heading-02 font-bold">Project name</label>
								</div>
								<div className="order-2 w-2/4 capitalize">
									<span>{projectName}</span>
								</div>
							</div>
							<div className="flex flex-row pb-6">
								<div className="order-1 w-1/4">
									<label className="text-heading-02 font-bold break-words">Project description</label>
								</div>
								<div className="order-2 w-2/4">
									<span>{projectDescription}</span>
								</div>
							</div>
							<div className="flex flex-row pb-6">
								<div className="order-1 w-1/4">
									<label className="text-heading-02 font-bold">Marketplace location</label>
								</div>
								<div className="order-2 w-2/4">
									{appStore === "US" && <span>U.S. Marketplace</span>}
									{appStore === "CA" && <span>CA Marketplace</span>}
								</div>
							</div>
							<div className="flex flex-row pb-6">
								<div className="order-1 w-1/4">
									<label className="text-heading-02 font-bold">ADP product</label>
								</div>
								<div className="order-2 w-2/4">
									<span className="capitalize">{productIntegration}</span>
								</div>
							</div>
							<div className="flex flex-row pb-6">
								<div className="order-1 w-1/4">
									<label className="text-heading-02 font-bold">Use case</label>
								</div>
								<div className="order-2 w-2/4">
									<span className="capitalize">{useCaseName}</span>
								</div>
							</div>
							<div className="flex flex-row pt-4 pb-12">
								If you need to make changes to any section, select the back button; otherwise, generate project to continue.
							</div>
						</div>
					</section>
				</div>
			</div>
		</>
	)
}

export default StepFive;
